import React from "react";

/**
 * Tag Display Component
 * Displays tag information with icon when tag is not available
 */
const TagDisplay = ({ tag, tagEdit, onClick, onTagClick, className = "" }) => {
  const tagIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.9119 23C13.1542 23 12.4419 22.7048 11.9066 22.1695L1.83081 12.0945C1.17489 11.4386 0.881077 10.5022 1.04426 9.5892L1.99398 4.28519C2.20208 3.12282 3.12293 2.202 4.28535 1.99391L9.58953 1.04422C10.5067 0.881044 11.4395 1.1753 12.0949 1.83074L22.1712 11.9052C23.2763 13.0108 23.2763 14.8102 22.1712 15.9158L15.9172 22.1695C15.3819 22.7053 14.6696 23 13.9119 23ZM20.8749 13.2014L10.7992 3.12649C10.6094 2.93674 10.3532 2.83269 10.0896 2.83269C10.0309 2.83269 9.97181 2.83773 9.91314 2.84827L4.60895 3.79797C4.19826 3.87131 3.87282 4.19673 3.79902 4.60787L2.84929 9.91187C2.79154 10.2346 2.89559 10.5659 3.12706 10.7979L13.2028 20.8728C13.5814 21.2514 14.2415 21.2514 14.6201 20.8728L20.874 14.6191C21.265 14.2281 21.265 13.5919 20.874 13.201L20.8749 13.2014Z"
        fill="#96A8BA"
        stroke="white"
        strokeWidth="0.2"
      />
      <path
        d="M7.5 9C6.67157 9 6 8.32843 6 7.5C6 6.67157 6.67157 6 7.5 6C8.32843 6 9 6.67157 9 7.5C9 8.32843 8.32843 9 7.5 9Z"
        fill="#96A8BA"
        stroke="white"
        strokeWidth="0.2"
      />
    </svg>
  );

  const displayTag = tagEdit || (tag ? tag.tag_name : null);

  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) onClick(e);
  };

  const handleTagClick = (e) => {
    e.stopPropagation();
    if (onTagClick) {
      onTagClick(e);
    } else if (onClick) {
      onClick(e);
    }
  };

  return (
    <div className={`tag-section ${className}`} onClick={handleClick}>
      <p
        className={`cursor ${tag ? "tag-available" : "tag-not-available"}`}
        onClick={handleTagClick}
      >
        <span className="tooltip-tracker">
          {displayTag ? displayTag : tagIcon}
        </span>
        <span
          className="tag-edit-tag-name"
          style={{
            display: "inline-block",
            maxWidth: "180px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {displayTag ? displayTag : tagIcon}
        </span>
      </p>
    </div>
  );
};

export default TagDisplay;
